import React, { useState } from 'react';
import { Lock, Shield, Check, CreditCard, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
interface CheckoutPageProps {
  dogName: string;
}
export function CheckoutPage({
  dogName
}: CheckoutPageProps) {
  const [orderBump, setOrderBump] = useState(false);
  const basePrice = 17;
  const bumpPrice = 7;
  const total = orderBump ? basePrice + bumpPrice : basePrice;
  return <div className="min-h-screen bg-background pb-12 max-w-md mx-auto" data-id="element-6">
      {/* Header */}
      <div className="bg-white p-4 border-b border-gray-100 sticky top-0 z-10" data-id="element-7">
        <div className="flex items-center justify-center gap-2 text-sm font-bold text-text-main" data-id="element-8">
          <Lock className="w-4 h-4 text-green-600" data-id="element-9" />
          Resumen de tu Pedido
        </div>
      </div>

      <div className="p-4 space-y-6" data-id="element-10">
        {/* Order Summary */}
        <div className="bg-white rounded-xl shadow-sm border border-primary/20 overflow-hidden" data-id="element-11">
          <div className="bg-primary/5 p-4 border-b border-primary/10" data-id="element-12">
            <h3 className="font-bold text-text-main" data-id="element-13">
              Plan Personalizado para {dogName}
            </h3>
          </div>
          <div className="p-4 space-y-3" data-id="element-14">
            <div className="flex justify-between text-sm" data-id="element-15">
              <span className="text-text-main/80" data-id="element-16">
                Guía Anti-Envejecimiento
              </span>
              <span className="font-bold" data-id="element-17">$17.00</span>
            </div>
            <div className="flex justify-between text-sm text-green-600" data-id="element-18">
              <span data-id="element-19">+ 3 Bonus Exclusivos</span>
              <span data-id="element-20">GRATIS</span>
            </div>
            {orderBump && <div className="flex justify-between text-sm text-accent animate-in fade-in" data-id="element-21">
                <span data-id="element-22">+ Audioguía Práctica</span>
                <span data-id="element-23">$7.00</span>
              </div>}
            <div className="border-t border-dashed border-gray-200 pt-3 flex justify-between items-end" data-id="element-24">
              <span className="text-sm font-bold text-text-main" data-id="element-25">
                Total a pagar:
              </span>
              <span className="text-2xl font-extrabold text-text-main" data-id="element-26">
                ${total} USD
              </span>
            </div>
          </div>
        </div>

        {/* Guarantee Badge */}
        <div className="flex items-center justify-center gap-2 text-xs text-green-700 bg-green-50 p-2 rounded-lg border border-green-100" data-id="element-27">
          <Shield className="w-4 h-4" data-id="element-28" />
          <span data-id="element-29">Garantía de 7 días sin riesgos</span>
        </div>

        {/* Order Bump */}
        <div className="border-2 border-dashed border-accent/40 bg-accent/5 rounded-xl p-4 relative" data-id="element-30">
          <div className="absolute -top-3 left-4 bg-accent text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wide" data-id="element-31">
            Oferta Única
          </div>
          <div className="flex gap-3 items-start" data-id="element-32">
            <input type="checkbox" id="bump" checked={orderBump} onChange={e => setOrderBump(e.target.checked)} className="mt-1 w-5 h-5 text-accent rounded focus:ring-accent border-gray-300" data-id="element-33" />
            <label htmlFor="bump" className="text-sm cursor-pointer select-none" data-id="element-34">
              <span className="font-bold text-text-main block mb-1" data-id="element-35">
                SÍ, quiero la Audioguía por solo $7 más
              </span>
              <span className="text-text-main/70 text-xs leading-relaxed block" data-id="element-36">
                Escucha el protocolo mientras cocinas, sin tener que leer el
                PDF. Ideal para aplicar más rápido.
              </span>
            </label>
          </div>
        </div>

        {/* Form */}
        <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-37">
          <h3 className="font-bold text-text-main text-sm uppercase tracking-wide mt-6" data-id="element-38">
            Datos de Acceso
          </h3>

          <div className="space-y-3" data-id="element-39">
            <input type="text" placeholder="Nombre Completo" className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none" data-id="element-40" />
            <input type="email" placeholder="Tu mejor email (para enviarte la guía)" className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none" data-id="element-41" />
            <select className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none bg-white" data-id="element-42">
              <option value="" data-id="element-43">Selecciona tu país...</option>
              <option value="MX" data-id="element-44">🇲🇽 México</option>
              <option value="CO" data-id="element-45">🇨🇴 Colombia</option>
              <option value="AR" data-id="element-46">🇦🇷 Argentina</option>
              <option value="CL" data-id="element-47">🇨🇱 Chile</option>
            </select>
          </div>

          <h3 className="font-bold text-text-main text-sm uppercase tracking-wide mt-6" data-id="element-48">
            Pago Seguro
          </h3>

          <div className="grid grid-cols-2 gap-3" data-id="element-49">
            <button className="flex items-center justify-center gap-2 p-3 border-2 border-primary bg-primary/5 rounded-lg font-bold text-primary text-sm" data-id="element-50">
              <CreditCard className="w-4 h-4" data-id="element-51" /> Tarjeta
            </button>
            <button className="flex items-center justify-center gap-2 p-3 border border-gray-200 rounded-lg text-gray-600 text-sm hover:bg-gray-50" data-id="element-52">
              PayPal
            </button>
          </div>

          <Button fullWidth size="xl" className="mt-8 shadow-xl" data-id="element-53">
            ✅ COMPLETAR COMPRA →
          </Button>

          <div className="flex justify-center gap-4 text-[10px] text-gray-400 mt-4" data-id="element-54">
            <span className="flex items-center gap-1" data-id="element-55">
              <Lock className="w-3 h-3" data-id="element-56" /> SSL Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-57">
              📧 Entrega Inmediata
            </span>
          </div>

          {/* Payment method logos */}
          <div className="flex items-center justify-center gap-3 flex-wrap px-2 mt-4" data-id="element-58">
            <div className="bg-white border border-gray-200 rounded px-2 py-1 flex items-center justify-center h-8" data-id="element-59">
              <span className="text-[10px] font-bold text-blue-700 tracking-wider" data-id="element-60">
                VISA
              </span>
            </div>
            <div className="bg-white border border-gray-200 rounded px-2 py-1 flex items-center justify-center h-8" data-id="element-61">
              <div className="flex" data-id="element-62">
                <div className="w-4 h-4 rounded-full bg-red-500 opacity-80" data-id="element-63"></div>
                <div className="w-4 h-4 rounded-full bg-yellow-400 opacity-80 -ml-1.5" data-id="element-64"></div>
              </div>
            </div>
            <div className="bg-white border border-gray-200 rounded px-2 py-1 flex items-center justify-center h-8" data-id="element-65">
              <span className="text-[9px] font-bold text-blue-500" data-id="element-66">AMEX</span>
            </div>
            <div className="bg-white border border-gray-200 rounded px-2 py-1 flex items-center justify-center h-8" data-id="element-67">
              <span className="text-[9px] font-bold text-blue-800" data-id="element-68">PayPal</span>
            </div>
            <div className="bg-white border border-gray-200 rounded px-2 py-1 flex items-center justify-center h-8" data-id="element-69">
              <svg viewBox="0 0 48 48" className="h-5 w-auto" fill="none" data-id="element-70">
                <circle cx="24" cy="24" r="22" fill="#00BCFF" data-id="element-71" />
                <path d="M14 20c2-4 6-6 10-6s8 2 10 6c-2 4-6 6-10 6s-8-2-10-6z" fill="white" data-id="element-72" />
                <circle cx="24" cy="20" r="3" fill="#00BCFF" data-id="element-73" />
              </svg>
            </div>
          </div>
        </form>
      </div>
    </div>;
}